export const customTheme = {
  searchInput: {
    text: {
      boxShadow: 'none',
      background: 'white',
      height: '60px',
      padding: '0 10px',
      margin: '16px 0',
      border: '2px solid #B8B4B4',
      label: {
        fontSize: '16px',
        color: '#332927',
        marginTop: '20px',
      },
      detail: {
        fontSize: '11px',
        color: '#332927',
        top: '9px',
      },
      placeholder: {
        label: {
          top: '18px',
          fontSize: '14px',
          color: '#706967',
        },
        detail: {
          color: '#b8b4b4',
        },
      },
    },
  },
  input: {
    border: '#B8B4B4',
    errorColor: '#ff2525',
  },
  textarea: {
    fontSize: '14px',
    border: '2px solid #B8B4B4',
  },
};
